import React from 'react';

import { DetailedIconMegaphone, Spacer } from '@zillow/constellation';
import { Heading, Text } from '@zillow/constellation-10';

import { StyledContainer, StyledIconAwardRibbon } from './StyledComponents';

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  backgroundColor?: string;
  header?: string | null;
  isPremiumTip?: boolean;
};

const WizardTipCard = ({
  icon = <DetailedIconMegaphone />,
  children = null,
  backgroundColor = 'backgroundWhite',
  header = null,
  isPremiumTip = false,
}: Props) => (
  <StyledContainer className="WizardTipCard" backgroundColor={backgroundColor} isPremiumTip={isPremiumTip}>
    <Spacer marginBottom="sm">
      {isPremiumTip ? (
        <>
          <StyledIconAwardRibbon fontColor="brand" size="xs" />
          <Text textStyle="body-sm-bold" css={{ color: 'blue.400' }} asChild>
            <span> Premium</span>
          </Text>
        </>
      ) : (
        icon
      )}
    </Spacer>

    {header && (
      <Spacer marginBottom="sm">
        <Heading level={6} id="tip-title">
          {header}
        </Heading>
      </Spacer>
    )}

    {children}
  </StyledContainer>
);

export default WizardTipCard;
